module.exports = __webpack_public_path__ + "static/media/ticket-white.2a6fe16e.svg";